import { render, staticRenderFns } from "./AttendanceArriveOfMonth.vue?vue&type=template&id=00673f10&scoped=true"
import script from "./AttendanceArriveOfMonth.vue?vue&type=script&lang=js"
export * from "./AttendanceArriveOfMonth.vue?vue&type=script&lang=js"
import style0 from "./AttendanceArriveOfMonth.vue?vue&type=style&index=0&id=00673f10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00673f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00673f10')) {
      api.createRecord('00673f10', component.options)
    } else {
      api.reload('00673f10', component.options)
    }
    module.hot.accept("./AttendanceArriveOfMonth.vue?vue&type=template&id=00673f10&scoped=true", function () {
      api.rerender('00673f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/AttendanceArriveOfMonth.vue"
export default component.exports